import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpLocationSearchParams extends SearchParamsBase {
  initialize() {
    this.TPLocationID = '';
    this.ThirdPartyClientId = '';
    this.BravoClientId = '';
    this.ThirdPartyLocationId = '';
    this.ThirdPartyLocationName = '';
    this.LinkedToCaspianClient = true;
  }

  static fieldsInSearchBox = [
    { fieldName: 'ThirdPartyClientId', label: 'Third-Party Client Id', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TPLocationID', label: 'TPLocationID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'BravoClientId', label: 'BravoClientId', className: 'col-3', type: InputTypesEnum.Number },
    {
      fieldName: 'ThirdPartyLocationId',
      label: 'ThirdPartyLocationId',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartyLocationName',
      label: 'ThirdPartyLocationName',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'LinkedToCaspianClient',
      label: 'Linked to Bravo Client',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpLocationSearchParams';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
